import {HttpClientService} from "services/httpClient/httpClientService";
import config from "config/config";
import {ApiResponse} from "services/api/apiResponse"
import {AccountService} from "../../account/accountService";
import {ForSelectModel} from "../../../core/sharedmodels/forSelectModel";
import {ForSelectResponseModel} from "../forSelectResponseModel";

export class StamdataPostnummerApi {
    private httpClientService: HttpClientService;
    private userService: AccountService;
    private baseUrl = () => config.stamdataApiUrl + "api/postnummer/";

    constructor(httpClientService: HttpClientService, userService: AccountService) {
        this.httpClientService = httpClientService;
        this.userService = userService;
    }

    async getPostnummerSelect(): Promise<ForSelectModel[]> {
        const url = this.baseUrl() + "PostnummerForSelect";
        const result = await this.httpClientService.Get<ApiResponse<ForSelectResponseModel[]>>(url);
        return result.data.map(x => new ForSelectModel(x));
    }
}
